"use strict";
exports.__esModule = true;
exports.withTheme = exports.ThemeProvider = exports.keyframes = exports.createGlobalStyle = exports.css = void 0;
var tslib_1 = require("tslib");
// styled-components.ts
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
exports.css = styled_components_1.css;
exports.createGlobalStyle = styled_components_1.createGlobalStyle;
exports.keyframes = styled_components_1.keyframes;
exports.ThemeProvider = styled_components_1.ThemeProvider;
exports.withTheme = styled_components_1.withTheme;
exports["default"] = styled_components_1["default"];
